import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalTranslationApiService } from 'src/app/api/global-translations-api.service';

@Component({
  selector: 'app-edit-global-translation-modal',
  templateUrl: './edit-global-translation-modal.component.html',
  styleUrls: ['./edit-global-translation-modal.component.scss']
})
export class EditGlobalTranslationModalComponent  {

  @Input() entityType!: string;
  @Input() translations!: any[];
  @Input() refValue!: string;
  @Input() multiline!: boolean;


  constructor(
    public activeModal: NgbActiveModal,
    public globalTranslationApiService : GlobalTranslationApiService
  ) { }

  async saveTranslations() {
    this.activeModal.close(this.translations);
  }

  async getTrad(trans: any) {
    try {
      let translation = await this.globalTranslationApiService.getSingleTranslation(trans.codeLang, this.refValue)
      trans.value = translation.translation;
      
    } catch (error) {
      trans.value = '! erreur !';
    }
     
  }

}
